import React, { useEffect, useState } from "react";
import { FaCheck, FaCreditCard, FaShieldAlt } from "react-icons/fa";
import { useParams, useSearchParams } from "react-router-dom";
import { apiGet } from "../../api/api_methods";
const Payment = () => {
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [subscriptionDetails2, setSubscriptionDetails2] = useState(null);
  const [isThisSubscription, setIsThisSubscription] = useState(false);
  const [paymentURL, setPaymentURL] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [amount, setAmount] = useState(null);
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  useEffect(() => {
    // console.log(id);

    localStorage.removeItem("subscription");

    const fetchSubscriptionDetails = async () => {
      try {
        setIsLoading(true);
        const response = await apiGet(
          `/phonepe/verify-subscription-payment/${id}`
        );
        console.log(response.body.data.subscriptionId, "responseqq");
        const gateWayResponse = JSON.parse(response.body.data.gateWayResponse);
        console.log(gateWayResponse, "gateWayResponse");
        setIsThisSubscription(response.body.data.subscriptionId ? true : false);
        setSubscriptionDetails(response.body.data.subscriptionId);
        setSubscriptionDetails2(response.body.data);
        setAmount(response.body.data.paid);
        const paymentURL =
          gateWayResponse.data.data.instrumentResponse.redirectInfo.url;
        console.log(paymentURL, "paymentURL");
        setPaymentURL(paymentURL);
      } catch (error) {
        console.error("Error fetching subscription details:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchSubscriptionDetails();
  }, [id]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          {/* Header */}
          <div className="bg-primary px-6 py-8">
            {isThisSubscription && (
              <h2 className="text-3xl font-bold text-white">
                {subscriptionDetails?.name}
              </h2>
            )}
            <p className="mt-2 text-white">
              Complete your purchase to get started
            </p>
          </div>

          {/* Price Section */}
          <div className="px-6 py-8 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <FaCreditCard className="h-8 w-8 text-primary" />
                <div className="ml-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    Payment Details
                  </h3>
                  <p className="text-sm text-gray-500">
                    Secure payment processing
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-4xl font-bold text-gray-900">₹ {amount}</p>
                {isThisSubscription && (
                  <p className="text-sm text-gray-500">per month</p>
                )}
              </div>
            </div>
          </div>

          {/* Features Section */}
          <div className="px-6 py-8">
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              Plan Features
            </h3>
            {isThisSubscription ? (
              <ul className="space-y-4">
                {subscriptionDetails?.featureUsage?.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <FaCheck className="h-5 w-5 text-green-500 mt-1" />
                  <span className="ml-3 text-gray-700">
                    {feature.limit ?? null} {feature.name}
                  </span>
                </li>
              ))}
            </ul>
            ) : (
              <ul className="space-y-4">
                {subscriptionDetails2?.features
                  ?.filter((feature) => feature.count > 0)
                  .map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="h-5 w-5 text-green-500 mt-1" />
                      <span className="ml-3 text-gray-700">
                    {feature.count ?? null} {feature.name}
                  </span>
                </li>
              ))}
            </ul>
            )}
          </div>

          {/* Security Notice */}
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
            <div className="flex items-center">
              <FaShieldAlt className="h-5 w-5 text-primary" />
              <p className="ml-3 text-sm text-gray-500">
                Your payment information is secure and encrypted
              </p>
            </div>
          </div>

          {/* Payment Button */}
          <div className="px-6 py-4 bg-gray-50">
            <button
              className="w-full bg-primary text-white py-3 px-4 rounded-md hover:bg-primary/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-200"
              onClick={() => {
                if(type !== "increase-limit") {

                  localStorage.setItem("subscription", true);
                }
                window.location.href = paymentURL;
              }}
            >
              Confirm Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payment;
